import React, { memo } from 'react'
import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Link from 'next/link'
import Image from 'next/legacy/image'

// Estilos
import sx from './styles'

const OnedayHeader = () => {
  return (
    <AppBar
      sx={sx.appBar}
      component="header"
      id="OnedayHeader"
    >
      <Container maxWidth="xl">
        <Toolbar
          sx={sx.toolbar}
          disableGutters
        >
          <Link
            href="/"
            passHref
            legacyBehavior
          >
            <Box
              component="a"
              sx={sx.logoContainer}
              aria-label="Ir al inicio de ClikAuto"
            >
              <Image
                src="/oneday_assets/oneday_logos/clikautoLogo.svg"
                alt="ClikAuto Logo"
                width={180}
                height={50}
                layout="intrinsic"
                objectFit="contain"
                priority
              />
            </Box>
          </Link>
        </Toolbar>
      </Container>
    </AppBar>
  )
}

export default memo(OnedayHeader)
